import {
  SupportTicketCategory,
  SupportTicketPriority,
  SupportTicketType,
} from '@repo/database/browser';
import z from '@/lib/zod';
import { toLegacySubTab } from '@/lib/helpers/list-tabs';
import { SUPPORT_TICKETS_TABS } from '@/pages/support-tickets/lib/support-tickets-filters';
import { TICKET_DETAIL_TABS } from '@/pages/support-tickets/lib/ticket-detail-tabs';
import { commonSearchSchema } from './commonSearchSchema';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from './search-param-schemas';

/**
 * Filtri della coda ticket. Vive fuori dai file di rotta perche' lista e
 * deep-link al dettaglio devono validare gli stessi parametri: uno schema
 * piu' stretto sul dettaglio scarterebbe i filtri al ritorno in lista.
 */
export const supportTicketsSearchSchema = commonSearchSchema
  .extend({
    /** Tab della coda (come la webapp). */
    subTab: optionalSearchString(),
    /**
     * Link di prima (dashboard, segnalibri) con lo stato: diventa `subTab`
     * e non esce dallo schema. Da rimuovere dopo il 2026-12-31.
     */
    status: optionalSearchString(),
    priority: z.enum(SupportTicketPriority).nullish().catch(undefined),
    category: z.enum(SupportTicketCategory).nullish().catch(undefined),
    type: z.enum(SupportTicketType).nullish().catch(undefined),
    tenantId: optionalSearchString(),
    assignedToId: optionalSearchString(),
    onlyMine: optionalSearchBoolean(),
    unassigned: optionalSearchBoolean(),
    createdFrom: optionalSearchString(),
    createdTo: optionalSearchString(),
    /** Scheda del dettaglio `/$id`; la lista non la legge. */
    tab: z.enum(TICKET_DETAIL_TABS).nullish().catch(undefined),
  })
  .transform(({ status, ...search }) => ({
    ...search,
    subTab: toLegacySubTab({
      tabs: SUPPORT_TICKETS_TABS,
      subTab: search.subTab,
      legacyFilter: status,
    }),
  }));

export type SupportTicketsSearch = z.output<typeof supportTicketsSearchSchema>;
